module.exports = __webpack_public_path__ + "static/media/icon-reader.f31ac899.svg";